module.exports = __webpack_public_path__ + "img/sort-all.f5c82d82.svg";